/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MarqCommonProtocolEmptyResponse,
  OfficialImageProtocolsCreateCollectionRequest,
  OfficialImageProtocolsCreateCollectionResponse,
  OfficialImageProtocolsCreateOfficialImagesPresignedRequest,
  OfficialImageProtocolsDeleteCollectionRequest,
  OfficialImageProtocolsDeleteOfficialImageRequest,
  OfficialImageProtocolsGetAllCollectionsRequest,
  OfficialImageProtocolsGetAllCollectionsResponse,
  OfficialImageProtocolsGetAllOfficialImagesRequest,
  OfficialImageProtocolsGetAllOfficialImagesResponse,
  OfficialImageProtocolsGetCollectionDetailsRequest,
  OfficialImageProtocolsGetCollectionDetailsResponse,
  OfficialImageProtocolsGetOfficialImagePresignedUrlRequest,
  OfficialImageProtocolsGetOfficialImagePresignedUrlResponse,
  OfficialImageProtocolsUpdateCollectionRequest,
  OfficialImageProtocolsUpdateOfficialImageRequest,
} from './data-contracts';
import { ContentType, HttpClient, RequestParams } from './http-client';

export class OfficialImage<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags OfficialImage
   * @name AllOfficialImagesCreate
   * @request POST:/official-image/all_official_images
   */
  allOfficialImagesCreate = (data: OfficialImageProtocolsGetAllOfficialImagesRequest, params: RequestParams = {}) =>
    this.http.request<OfficialImageProtocolsGetAllOfficialImagesResponse, any>({
      path: `/official-image/all_official_images`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name PresignedCreate
   * @request POST:/official-image/presigned
   */
  presignedCreate = (data: OfficialImageProtocolsGetOfficialImagePresignedUrlRequest, params: RequestParams = {}) =>
    this.http.request<OfficialImageProtocolsGetOfficialImagePresignedUrlResponse, any>({
      path: `/official-image/presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name CreateOfficialImagesPresignedCreate
   * @request POST:/official-image/create_official_images_presigned
   */
  createOfficialImagesPresignedCreate = (
    data: OfficialImageProtocolsCreateOfficialImagesPresignedRequest,
    params: RequestParams = {}
  ) =>
    this.http.request<void, any>({
      path: `/official-image/create_official_images_presigned`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name UpdateOfficialImageCreate
   * @request POST:/official-image/update_official_image
   */
  updateOfficialImageCreate = (data: OfficialImageProtocolsUpdateOfficialImageRequest, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/official-image/update_official_image`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name DeleteImageCreate
   * @request POST:/official-image/delete_image
   */
  deleteImageCreate = (data: OfficialImageProtocolsDeleteOfficialImageRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/official-image/delete_image`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name CollectionDetailsCreate
   * @request POST:/official-image/collection_details
   */
  collectionDetailsCreate = (data: OfficialImageProtocolsGetCollectionDetailsRequest, params: RequestParams = {}) =>
    this.http.request<OfficialImageProtocolsGetCollectionDetailsResponse, any>({
      path: `/official-image/collection_details`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name GetCollectionsCreate
   * @request POST:/official-image/get_collections
   */
  getCollectionsCreate = (data: OfficialImageProtocolsGetAllCollectionsRequest, params: RequestParams = {}) =>
    this.http.request<OfficialImageProtocolsGetAllCollectionsResponse, any>({
      path: `/official-image/get_collections`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name CreateCollectionCreate
   * @request POST:/official-image/create_collection
   */
  createCollectionCreate = (data: OfficialImageProtocolsCreateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<OfficialImageProtocolsCreateCollectionResponse, any>({
      path: `/official-image/create_collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name UpdateCollectionCreate
   * @request POST:/official-image/update_collection
   */
  updateCollectionCreate = (data: OfficialImageProtocolsUpdateCollectionRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/official-image/update_collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
  /**
   * No description
   *
   * @tags OfficialImage
   * @name DeleteCollectionCreate
   * @request POST:/official-image/delete_collection
   */
  deleteCollectionCreate = (data: OfficialImageProtocolsDeleteCollectionRequest, params: RequestParams = {}) =>
    this.http.request<MarqCommonProtocolEmptyResponse, any>({
      path: `/official-image/delete_collection`,
      method: 'POST',
      body: data,
      type: ContentType.Json,
      format: 'json',
      ...params,
    });
}
